import './App.css';
import Terms from "../src/pages/terms"
import Privacy from "../src/pages/privacy"
import Home from "../src/pages/home"
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';


function App() {
  return (
    <Router>
   
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/terms" element={<Terms/>} />
      <Route path="/privacy" element={<Privacy/>} />
    </Routes>
  </Router>
  
  );
}

export default App;
